/**
 * Read every selected file as text for a CaptureComponent's (multi-)file input.
 * Validates each is a `.csv`; on the first non-CSV or a read failure it calls
 * `onError` and returns null. Otherwise returns the texts in selection order,
 * which the wizard parses one-by-one and concatenates.
 */
export async function readCsvFileTexts(
  fileList: FileList | null,
  onError: (message: string) => void,
  label = 'CSV export',
): Promise<string[] | null> {
  const files = fileList ? Array.from(fileList) : [];
  if (files.length === 0) return null;
  const bad = files.find((f) => !/\.csv$/i.test(f.name));
  if (bad) {
    onError(`“${bad.name}” isn’t a .csv file. Please choose ${label} files (.csv).`);
    return null;
  }
  try {
    return await Promise.all(files.map((f) => f.text()));
  } catch {
    onError('Failed to read file.');
    return null;
  }
}
